<div class="slider-item"
  [ngClass]="{'slider-item-selector': !slidItemClass, 'zindex': addZindex, 'cardOverlay': currentlyPlaying}"
  [@videoCardAnimation] (click)="videoCardFullClick(video)">
  <!-- <div class="slider-img" [attr.vidoe-slug]="video.slug" lazy-load-images (click)="videoClick(video);"> -->

  <div class="slider-img" [attr.vidoe-slug]="video.slug" lazy-load-images (click)="videoClick(video);">
    <img [attr.alt]="video.title" src="https://dyo1wwfvu9av7.cloudfront.net/jkp/common/default-poster.png"
      [attr.data-src]="video.thumbnail_image">
    <span class="free-tag"> Free</span>
    <span class="premium-tag pts" *ngIf="video?.is_premium === 1">P
    </span>
    <span *ngIf="type === 'favorite'" class="like-box" (click)="favourite(video, $event)"><i
        [ngClass]="'liked'"></i></span>
    <div *ngIf="video?.video_duration" class="duration">{{video?.video_duration}}</div>
  </div>
  <div class="slider-content">
    <ng-container *ngIf="type !== 'web-series'">
      <!-- _highlight comes from the search API (matched words wrapped in <em>) -->
      <h3 (click)="videoClick(video)" *ngIf="currentSiteLang === 'en'"
        [innerHTML]="(video?._highlight && video._highlight['english.title']) || video?.english?.title"></h3>
      <p (click)="videoClick(video)" *ngIf="currentSiteLang === 'hi'"
        [innerHTML]="(video?._highlight && video._highlight['hindi.title']) || video?.hindi?.title"></p>
      <!-- <span class="category-text" (click)="videoClick(video, undefined);"
      *ngIf="type !== 'search' && type !== 'upcoming'">
      <ng-container *ngIf="category !== 'genre' && type !== 'upcoming' && type !== 'live'">
        {{video?.genre_name}}<i
          *ngIf="video?.genre_name && category !== 'genre' && category !== 'category' && video?.video_category_name">,</i>
      </ng-container>
      <ng-container *ngIf="video?.video_category_name && category !== 'category'">
        {{video?.video_category_name}}
      </ng-container>
    </span> -->

      <!-- <span class="category-text" *ngIf="type === 'search'" (click)="videoClick(video, undefined);">
      {{video?.genre_name}}<i *ngIf="video?.genre_name">,</i>{{video?.video_category_name}}
    </span> -->
    </ng-container>
  </div>
</div>